import React, { useState, useRef, useEffect } from 'react'
import CommonSelect from './commonSelect';
import { useSelector } from 'react-redux';
import { applyNewApmcApplication, getApmcPurposes, getYardsAPMC, submitAnnexureOne } from '../../../auth/services/privateapicalling';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { label } from 'yet-another-react-lightbox/*';
import { languageMapping } from '../../AllSchemes/GujaratScheme';
import { schemeIdMap, yardOptions } from '../../../../core/data/json/apmc';
interface APMCp1Props {
  onNext: () => void;
  formData: any;
  userDetail: any;
  couchID?: string;
  getExistedApplication?: (applicationId: string) => void;
  isGettingApplication?: boolean;
  setIsGettingApplication?: React.Dispatch<React.SetStateAction<boolean>>;
  purpose?: any;
  applicationId?: string;
  setApplicationId?: React.Dispatch<React.SetStateAction<string | null>>;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement> , documentName: string) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  districtOptions: { label: string; value: string }[];
  talukaOptions: { label: string; value: string }[];  
  apmcOptions: { label: string; value: string }[];
  selectedSchemeDetails: {
  name: string;
  purposes: string[];
  } | null;
  schemesSelected:string;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  setCouchID:React.Dispatch<React.SetStateAction<string | null>>;
}

const APMCp1 = ({
  onNext,
  formData,
  userDetail,
  couchID,
  setCouchID,
  handleFileChange,
  getExistedApplication,
  handleInputChange,
  districtOptions,
  talukaOptions,
  apmcOptions,
  purpose,
  isGettingApplication,
  setIsGettingApplication,
  applicationId,
  setApplicationId,
  selectedSchemeDetails,
  schemesSelected,
  setFormData,
  
}: APMCp1Props) => {

  const token = useSelector((state:any)=>state.auth.token);
  const [submitLoading, setSubmitLoading] = useState(false);  
  



  const handleCommonSelectChange = (
  option: { value: string; label: string } | null,
  name?: string
) => {
  if (!name) return;

  const label = option ? option.label : "";

  // Pass fake event to handleInputChange
  handleInputChange({
    target: { name, value: label },
  } as React.ChangeEvent<HTMLInputElement>);
};

 // ERROR Handling
  const [error, setError] = useState<string | null>(null);
  const [isPressed, setIsPressed] = useState(false);
// ------------------------------------Field and purpose select in 07. ----------------------------------
  // const [purposeCosts, setPurposeCosts] = useState<{[key: string]: string}>({});
  // Get all unique purposes across selected yards
const getAllSelectedPurposes = () => {
  const allPurposes: any[] = [];
  const seenIds = new Set();
  
  selectedYards.forEach((yard) => {
    const purposes = yardPurposes[yard.value] || [];
    purposes.forEach((purpose) => {
      if (!seenIds.has(purpose.id)) {
        seenIds.add(purpose.id);
        allPurposes.push(purpose);
      }
    });
  });
  
  return allPurposes;
};

const handlePurposeCostChange = (purposeId: string, value: string) => {
  // Only allow positive numbers
  if (value && (parseFloat(value) < 0 || isNaN(parseFloat(value)))) {
    return;
  }
  
  setFormData(prev => ({
    ...prev,
    purposeCosts: {
      ...prev.purposeCosts,
      [purposeId]: value
    }
  }));
};

  //-------------------------------Yards ------------------------------------
  const [selectedYards, setSelectedYards] = useState<any[]>([]);
  const [yardPurposes, setYardPurposes] = useState<{[key: string]: any[]}>({});
  const [showAllPurposes, setShowAllPurposes] = useState<{yardValue: string, yardLabel: string} | null>(null);
  const [yardsData, setYardsData] = useState([])
  const [rawPurposes, setRawPurposes] = useState([])
 

const handleSelectScheme = async (scheme) => {
  try {
    const resp = await getApmcPurposes(scheme);
    const raw = resp?.data || [];

    const formattedPurposes = raw.map(item => {
      const langMatch = languageMapping.find(
        (l) => l.value.trim() === item.subName.trim()
      );

      const gujaratiLabel = langMatch ? langMatch.label : item.subName;

      return {
        label: `${gujaratiLabel} // ${item.subName}`,
        value: item.id,
        ...item
      };
    // }).slice(0, -1);   // remove last element
    });  


    setRawPurposes(formattedPurposes);
  

  } catch (error) {

  }
};

const fetchYardsAPMC=async()=>{
  try{
    const response=await getYardsAPMC(token);
    if(response?.success){
      setYardsData(response?.data?.allYards);
    }

  }catch{

  }
}



useEffect(() => {
  fetchYardsAPMC();
  handleSelectScheme(schemesSelected);
}, [token]);





const handleYardChange = (selected: any) => {
  setSelectedYards(selected || []);
  
  if (selected) {
    const selectedValues = selected.map((yard: any) => yard.value);
    const newPurposes: {[key: string]: any[]} = {};
    selectedValues.forEach((value: string) => {
      if (yardPurposes[value]) {
        newPurposes[value] = yardPurposes[value];
      }
    });
    setYardPurposes(newPurposes);
  } else {
    setYardPurposes({});
  }
};

const handlePurposeChange = (yardValue: string, selected: any) => {
  setYardPurposes(prev => ({
    ...prev,
    [yardValue]: selected || []
  }));
};

// Custom styles for Select component to show 2 values per line
const customSelectStyles = {
  multiValue: (base: any) => ({
    ...base,
    maxWidth: '48%', // your layout
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    // 🔥 NEW: transparent background
    backgroundColor: 'transparent',
    border: '1px solid #e5e7eb', // subtle border (optional)
    borderRadius: '6px',
  }),

  multiValueLabel: (base: any) => ({
    ...base,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',

    // 🔥 NEW: text color stays strong on white bg
    color: '#374151',
    fontWeight: 500,
  }),

  multiValueRemove: (base: any) => ({
    ...base,
    color: '#6b7280',
    ':hover': {
      backgroundColor: 'transparent',
      color: '#ef4444',
    },
  }),

  valueContainer: (base: any) => ({
    ...base,
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    padding: '8px',
  }),
};




const extractEnglish = (text) => {
  if (!text) return text;
  return text.includes(" // ") ? text.split(" // ")[1].trim() : text;
};

const buildYardPurposePayload = () => {
  const payload = {
    schemeId: schemeIdMap[schemesSelected],     // ✔ Send ID (53–59)
    // schemeId: 52,     // ✔ Send ID (53–59)
    // schemeName: schemesSelected,                // ✔ You can send name if backend needs it
    mainYard: [],
    subYard: []
  };

  selectedYards.forEach((yard) => {
    const englishYard = extractEnglish(yard.label);
    const purposes = yardPurposes[yard.value] || [];

    purposes.forEach((p) => {
      const englishPurpose = extractEnglish(p.label);

      const entry = {
        id: p.id,
        yard: englishYard,
        purpose: englishPurpose,
        type: yard.type
      };

      if (yard.type === "mainYard") {
        payload.mainYard.push(entry);
      } else {
        payload.subYard.push(entry);
      }
    });
  });

  return payload;
};







//----------------------------------Validation state----------------------------------

  const [touched, setTouched] = useState<{ [key: string]: boolean }>({});

  // Validation logic for each field
  const validate = () => {
    const errors: { [key: string]: string } = {};
    if (!formData.district) errors.district = "District is required.";
    if (!formData.taluka) errors.taluka = "Taluka is required.";
    if (!formData.apmcName) errors.apmcName = "APMC is required.";
    if (!formData.category_Label) errors.category_Label = "Category Label is required.";
    if (!formData.copyOfMarketCommitteEstDet  ) errors.copyOfMarketCommitteEstDet  = "Committee document is required.";
    if (!formData.certOfMarketCommitteCategory    ) errors.certOfMarketCommitteCategory     = "Category document is required.";
    // if (!formData.scheme) errors.scheme = "Scheme is required.";
    // if (!formData.purpose) errors.purpose = "Purpose is required.";
    if (!formData.planProjectCost) errors.planProjectCost = "Project plan is required.";
   // ----------------------------------------------------------------------------------------------// if (!formData.planEstimateProjectCost) errors.planEstimateProjectCost = "Project estimate is required.";
     const allPurposes = getAllSelectedPurposes();
  if (allPurposes.length > 0) {
    const missingCosts = allPurposes.filter(
      p => !formData.purposeCosts[p.id] || formData.purposeCosts[p.id] === ""
    );
    if (missingCosts.length > 0) {
      errors.purposeCosts = "Please enter costs for all selected purposes";
    }
  }
  
  if (!formData.planProjectCost) errors.planProjectCost = "Project plan is required.";
  
   // if (!formData.estimateProjectCostAmount && formData.estimateProjectCostAmount !== 0) errors.estimateProjectCostAmount = "Project Estimate Amount is required.";
    if (!formData.percentOfProjCostEligible && formData.percentOfProjCostEligible !== 0) errors.percentOfProjCostEligible = "Percentage is required.";
    if (!formData.planEstimateByApprovedPE) errors.planEstimateByApprovedPE = "Plan Estimate document is required.";
    if (!formData.estimatePlanConstruction) errors.estimatePlanConstruction = "Existing construction plan document is required.";
    if (!formData.estimateCertifiedByGovtEngineer) errors.estimateCertifiedByGovtEngineer = "PWD document is required.";
    if (!formData.toolsEquipQuotations) errors.toolsEquipQuotations = "Tools document is required.";
    if (!formData.isExistingConstructionOnProjSite) errors.isExistingConstructionOnProjSite = "Please select Yes or No.";
    return errors;
  };

  // --- Refs for focusing on error fields ---
  const refs = {
    district: useRef(null),
    taluka: useRef(null),
    apmcName: useRef(null),
    copyOfMarketCommitteEstDet: useRef(null),
    certOfMarketCommitteCategory: useRef(null),
    scheme: useRef(null),
    purpose: useRef(null),
    planProjectCost: useRef(null),
    estimateProjectCostAmount: useRef(null),
    // planEstimateProjectCost: useRef(null),
    percentOfProjCostEligible: useRef(null),
    planEstimateByApprovedPE: useRef(null),
    estimatePlanConstruction: useRef(null),
    toolsEquipQuotations: useRef(null),
    estimateCertifiedByGovtEngineer: useRef(null),
    isExistingConstructionOnProjSite: useRef(null),
    category_Label: useRef(null), // Uncomment if needed
  };

  const errors = validate();

//-----------------------------Mark input as touched on blur-----------------------------

  const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {
    setTouched(prev => ({ ...prev, [e.target.name]: true }));
  };

//-------------------------------------Next Click-------------------------------------
const buildAnnexureOnePayload = () => {

  const allPurposes = getAllSelectedPurposes();
  const estimateProjectCostAmount = allPurposes.map(purpose => ({
    id: purpose.id,
    name: extractEnglish(purpose.label),
    cost: parseFloat(formData.purposeCosts[purpose.id] || "0")  // CHANGED
  }));
  return {
    apmc: {
      data: [{
        value: formData.apmcName,
        fieldName: "apmcName",
      }
        , {
          value: formData.district,
          fieldName: "District",
        }, {
          value: formData.taluka,
          fieldName: "Taluka",
        }]
    },
    copyOfMarketCommitteEstDet: {
      data: formData.copyOfMarketCommitteEstDet
        ? [
          { docId: formData.copyOfMarketCommitteEstDet.docId, documentName: "copyOfMarketCommitteEstDet",fileName: formData?.copyOfMarketCommitteEstDet?.fileName }]
        : []
    },
    certOfMarketCommitteCategory: {
      data: formData.certOfMarketCommitteCategory
        ? [{value: formData.category_Label,fieldName: "MarketCommitteCategory"},
          { docId: formData.certOfMarketCommitteCategory.docId, documentName: "certOfMarketCommitteCategory", fileName: formData?.certOfMarketCommitteCategory?.fileName }]
        : []
    },
    // purposeOfAssistance: {
    //   data:[ {
    //     value: formData.scheme,
    //     fieldName: "scheme",
    //   },
    //     {
    //       value: formData.purpose,
    //       fieldName: "purpose",
    //     }]
    // },
    // estimateProjectCost: {
    //   data: formData.planProjectCost
    //     ? [
    //       { docId: formData.planProjectCost.docId, documentName: "planProjectCost",fileName: formData?.planProjectCost?.fileName },
    //       {value:formData?.estimateProjectCostAmount,fieldName:"estimateProjectCostAmount"}
    //     ]
    //     : []
    // },
        estimateProjectCost: {
      data: [
        ...(formData.planProjectCost ? [{
          docId: formData.planProjectCost.docId,
          documentName: "planProjectCost",
          fileName: formData?.planProjectCost?.fileName
        }] : []),
        {
          value: estimateProjectCostAmount,
          fieldName: "estimateProjectCostAmount"
        }
      ]
    },
 
    percentOfProjCostEligible: {
      data: [{
        value: formData.percentOfProjCostEligible,
        fieldName: "percentOfProjCostEligible"
      }] 
    },
    planEstimateByApprovedPE: {
      data: formData.planEstimateByApprovedPE
        ? [{ docId: formData.planEstimateByApprovedPE.docId, documentName: "planEstimateByApprovedPE", fileName: formData?.planEstimateByApprovedPE?.fileName }]
        : []
    },
    isExistingConstructionOnProjSite: {
    data: [
      {
        value: formData.isExistingConstructionOnProjSite,
        fieldName : "isExistingConstructionOnProjSite"
      }
    ]
  },
    toolsEquipQuotations: {
      data: formData.toolsEquipQuotations
        ? [{ docId: formData.toolsEquipQuotations.docId, documentName: "toolsEquipQuotations", fileName: formData?.toolsEquipQuotations?.fileName }]
        : []
    },
    estimatePlanConstruction: {
      data: formData.estimatePlanConstruction
        ? [{ docId: formData.estimatePlanConstruction.docId, documentName: "estimatePlanConstruction", fileName: formData?.estimatePlanConstruction?.fileName }]
        : []
    },
    estimateCertifiedByGovtEngineer: {
      data: formData.estimateCertifiedByGovtEngineer
        ? [{ docId: formData.estimateCertifiedByGovtEngineer.docId, documentName: "estimateCertifiedByGovtEngineer", fileName: formData?.estimateCertifiedByGovtEngineer?.fileName }]
        : []
    }
  };
};
  const handleNextClick = async() => {
    try {
      if (Object.keys(errors).length !== 0) {
        // Focus the first error field
        const firstErrorKey = Object.keys(errors)[0];
        if (firstErrorKey && refs[firstErrorKey] && refs[firstErrorKey].current) {
          // @ts-ignore
          refs[firstErrorKey].current.focus();
        }
       
        return;
      }
      const formdata = {
        schemeId: schemeIdMap[schemesSelected],
        departmentId: userDetail?.Department_ID,
        districtId: userDetail?.Department?.district_id,
        couchId: couchID,
        annexureOne: buildAnnexureOnePayload(),
      };
      const res = await submitAnnexureOne(formdata, token, applicationId);
      if (res?.success) {
   
        toast.success("Form submitted successfully",{position:"top-right"})
        onNext();
      }
 
    } catch (error) {
     
      // setError("Failed to submit the form. Please try again.");
      return;
    }
  };

  // Handle Proceed to Application click with yard purpose payload
const handleProceedToApplication = async () => {
  const yardPurposePayload = buildYardPurposePayload();


  // Validate if at least one yard is selected
  if (selectedYards.length === 0) {
    toast.error("Please select at least one yard", { position: "top-right" });
    return;
  }

  // Validate if all selected yards have purposes
  const yardsWithoutPurposes = selectedYards.filter(
    yard => !yardPurposes[yard.value] || yardPurposes[yard.value].length === 0
  );

  if (yardsWithoutPurposes.length > 0) {
    toast.error(`Please select purposes for all selected yards`, { position: "top-right" });
    return;
  }

  // If validation passes, proceed with API
  // toast.success("Payload validated successfully! Sending API...", { position: "top-right" });

  try {
    setSubmitLoading(true);
    
    const res = await applyNewApmcApplication(
      yardPurposePayload,
      token,
      "scheme"
    );

    if (res?.success === true) {
  
      setIsGettingApplication(false);
      toast.success("Yards submitted successfully! Start the Application", { position: "top-right" });
      setApplicationId(res?.data?.applicationId || null);
      setCouchID(res?.data?.applicationDataId || null);
      getExistedApplication(res?.data?.applicationId);
    } else {
     
      toast.warn(
        res?.message || "Already applied for this scheme",
        {
          position: "top-right",
          style: { fontSize: "1.2rem", padding: "16px" },
        }
      );
      setIsGettingApplication(true);

    }
  } catch (error) {
   
    setIsGettingApplication(true);
    toast.error("Something went wrong. Try again.", { position: "top-right" });
  }finally{
    setSubmitLoading(false);
  }

};

  

//----------------------------------Percentage(0-100)----------------------------------
const handlePercentageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  let value = e.target.value;

  // Accept valid decimals up to 2 decimal places
  if (!/^\d{0,3}(\.\d{0,2})?$|^\d+\.$/.test(value)) return;

  // Prevent values > 100
  const num = parseFloat(value);
  if (!isNaN(num) && num > 100) return;

  handleInputChange({
    target: {
      name: "percentOfProjCostEligible",
      value,
    },
  } as any);
};

const handlePercentageBlur = () => {
  const value = formData.percentOfProjCostEligible;
  if (value && /^\d+\.?$/.test(value)) {
    const formatted = parseFloat(value).toFixed(2);
    handleInputChange({
      target: { name: "percentOfProjCostEligible", value: formatted },
    } as any);
  }
};

  return (
    <>
      <div  className="page-wrapper ">
            <div className='d-flex flex-column text-nightblue align-items-center justify-content-center'>
                
              <div className='bg-white border border-secondary rounded-3 mb-4 w-100'>
                  <h4 className='m-3'>Select Yards and Their Purposes / યાર્ડ્સ અને તેમના હેતુઓ પસંદ કરો</h4>
                  <div className='d-flex flex-column m-3'>
                  <div className='d-flex flex-column align-items-center p-2 gap-2'>
                      {/* Main Yard Selector */}
                      <Select
                        options={yardsData?.length>0?yardsData:yardOptions}
                        placeholder="Select Yard/Sub Yards or both"
                        isMulti={true}
                        value={selectedYards}
                        onChange={handleYardChange}
                        closeMenuOnSelect={false}
                        className="w-100"
                      />

                      {/* Dynamic Purpose Selectors for each selected yard */}
                      {selectedYards.length > 0 && (
                        <div className="d-flex flex-column gap-3 w-100 mt-2">
                          {selectedYards.map((yard) => (
                            <div key={yard.value} className="w-100"> {/* Changed from yard.subName to yard.value */}
                              <div className="flex row">
                                <div className="col-4">
                                  <div className='p-2 rounded-top-2 border text-black' style={{backgroundColor:"#CCE3FF"}}>
                                    {yard.label}
                                  </div>
                                </div>
                                <div className="col-12">
                                  <Select
                                    styles={customSelectStyles}
                                    options={rawPurposes}
                                    isMulti
                                    placeholder="Select Purposes"
                                    value={yardPurposes[yard.value] || []}
                                    onChange={(selected) => handlePurposeChange(yard.value, selected)}
                                    closeMenuOnSelect={false}
                                  />
                                </div>
                              </div>
                              
                              {/* View All button */}
                              {yardPurposes[yard.value] && yardPurposes[yard.value].length > 0 && (
                                <div className="mt-2 d-flex justify-content-end px-2">
                                  <button
                                    type="button"
                                    className="btn btn-link p-0"
                                    style={{
                                      fontSize: '12px',
                                      textDecoration: 'none',
                                      color: '#3b82f6',
                                      whiteSpace: 'nowrap'
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setShowAllPurposes({yardValue: yard.value, yardLabel: yard.label});
                                    }}
                                  >
                                    View all ({yardPurposes[yard.value].length})
                                  </button>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                  </div>
              </div>
                 <div className='d-flex justify-content-end m-3'>
                   <button 
                     className='btn btn-info'
                     onClick={handleProceedToApplication}
                   >
                     Proceed to Application
                   </button>
                 </div>
                </div>
              {/* {isGettingApplication && (
                <div
                  style={{
                    position: "absolute",
                    top: "25%",
                    left: 0,
                    width: "100%",
                    height: "100%",                    
                    cursor: "not-allowed",
                  }}
                />
              )} */}

              { !isGettingApplication && <div id='table' className='w-100 bg- overflow-hidden border bg-white border-secondary rounded mb-5'>
                <div id='head' className='d-flex w-100 rounded-top border-bottom border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                    <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                    <h4 className='col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                    <h4 className='col-5 p-2 justify-content-center d-flex align-items-center'>જવાબ(Response)</h4>
                </div>
                <div className='d-flex border-bottom border-secondary'>
                    <h4 className='col-1  d-flex align-items-center justify-content-center'>01.</h4>
                    <div className='col-6 border-start border-end border-secondary  d-flex align-items-center justify-content-center p-2'>
                        <p className='p-2'>ખેતીવાડી ઉત્પન્ન બજાર સમિતિનું નામ અને સરનામું.(Name and address of the Agricultural Produce Market Committee).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                      <CommonSelect
                        className="select w-75 p-2 form-select"
                        options={districtOptions} //  Use API data
                        value={districtOptions.find((opt) => opt.label === formData.district) || null}
                        name="district"
                        onChange={handleCommonSelectChange}
                        isDisabled={true}
                        // ref={refs.district}
                      />

                      <CommonSelect
                        className="select w-75 p-2 mt-1 form-select"
                        options={talukaOptions}
                        value={talukaOptions[0]}
                        name="taluka"
                        onChange={handleCommonSelectChange}
                        isDisabled={true}
                        // ref={refs.taluka}
                      />

                      <CommonSelect
                        className="select w-75 p-2 mt-1 form-select"
                        options={apmcOptions}
                        value={apmcOptions[0]}
                        name="apmcName"
                        onChange={handleCommonSelectChange}
                        isDisabled={true}
                        // ref={refs.apmcName}
                      />
                      
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>02.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                    <p className='p-2'>
                        બજાર સમિતિની સ્થાપનાની વિગત (Details of establishment of the Market Committee - Copy of Government Notification).*
                    </p>
                    </div>
 
 
                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                    
                <input className='form-control w-75' type='file' onChange={(e) => handleFileChange(e, "copyOfMarketCommitteEstDet")} name="copyOfMarketCommitteEstDet" accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" id='uploadPlan' onBlur={handleBlur} ref={refs.copyOfMarketCommitteEstDet}></input>
               { formData?.copyOfMarketCommitteEstDet&&<p className="small text-success">Uploaded :{formData?.copyOfMarketCommitteEstDet?.fileName }</p>}
                      {errors && errors.copyOfMarketCommitteEstDet  && (
                        <span className="text-danger small">{errors.copyOfMarketCommitteEstDet }</span>
                      )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary'>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>03.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>બજાર સમિતિનો વર્ગ.<br />
                            (જિલ્લા રજિસ્ટ્રારશ્રીનું પ્રમાણપત્ર) સામેલ છે ? તેની નકલ Category of the Market Committee (Certificate from District Registrar).*</p>
                    </div>
                    <div  className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                     <Select
                      className="select z-0 w-75 p-2 form-select"
                      options={
                        [
                          { label: "A", value: "A" },
                          { label: "B", value: "B" },
                          { label: "C", value: "C" },
                          { label: "D", value: "D" },

                        ]
                      }
                      //  value={districtOptions[0]}
                      value={formData.category_Label ? { label: formData.category_Label, value: formData.category_Label } : null}
                      name="category_Label"
                      onChange={(selectedOption)=>handleCommonSelectChange(selectedOption, "category_Label")}
                      placeholder="Select Category"
                      // isDisabled={true}
                    />
                        {errors && errors.category_Label && (
                          <span className="text-danger small">{errors.category_Label}</span>
                        )}
                        <input 
                          type='file' 
                           onChange={(e)=>handleFileChange(e,"certOfMarketCommitteCategory")} 
                           name="certOfMarketCommitteCategory"
                          className="form-control w-75"   
                          accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"  
                          id="uploadPlan" 
                          ref={refs.certOfMarketCommitteCategory}
                />
                {formData?.certOfMarketCommitteCategory&&<p className="small text-success">Uploaded :{formData?.certOfMarketCommitteCategory?.fileName }</p>}
                        {errors && errors.certOfMarketCommitteCategory     && (
                          <span className="text-danger small">{errors.certOfMarketCommitteCategory    }</span>
                        )}
                    </div>
                </div>
 
              {/* FIELD 4 NOW AT THE TOP */}

              
                {/* <div className='d-flex border-bottom border-secondary'>
                  <h4 className='col-1 d-flex align-items-center justify-content-center'>04.</h4>
                  <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                      <p className='p-2'>આ યોજના હેઠળ કયા કયા હેતુઓ માટે સહાય મેળવવા માંગો છો ? (Purpose(s) for which assistance is requested under this scheme).*</p>
                  </div>
                  <div className='col-5 d-flex flex-column align-items-center p-2 gap-2'>
                     
                      <Select
                        
                        options={yardOptions}
                        placeholder="Select Yard/Sub Yards or both"
                        isMulti={true}
                        value={selectedYards}
                        onChange={handleYardChange}
                        closeMenuOnSelect={false}
                        className="w-75"
                      />

                      {selectedYards.length > 0 && (
                        <div className="d-flex flex-column gap-3 w-75 mt-2">
                          {selectedYards.map((yard) => (
                            <div key={yard.value} className="w-100">
                              <div className="row g-2">
                                <div className="col-12">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={yard.label}
                                    readOnly
                                    style={{
                                      height: '48px',
                                      borderRadius: '8px',
                                      border: '1px solid #d1d5db',
                                      backgroundColor: '#fff',
                                      color: '#6b7280'
                                    }}
                                  />
                                </div>
                                <div className="col-12">
                            <div style={{ position: "relative" }}>
                              <Select
                                // styles={customSelectStyles}
                                options={purposeOptions}
                                isMulti
                                placeholder="Select Purposes"
                                // value={yardPurposes[yard.value] || []}
                                onChange={(selected) => handlePurposeChange(yard.value, selected)}
                                closeMenuOnSelect={false}
                                // theme={(theme) => ({
                                //   ...theme,
                                //   colors: {
                                //     ...theme.colors,
                                //     primary: "#d1d5db",
                                //     primary25: "#f3f4f6",
                                //     primary50: "#e5e7eb",
                                //   },
                                // })}
                                menuPortalTarget={document.body}
                              />

                            {yardPurposes[yard.value]?.length > 0 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    left: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    pointerEvents: "none",
                                    color: "#374151",
                                    fontSize: "14px",
                                  }}
                                >
                                  {yardPurposes[yard.value].length} selected
                                </div>
                              )}
                            </div>

                                  
                                </div>
                              </div>
                              
                             
                              <button
                                    className="btn btn-link p-0 ms-2"
                                    style={{
                                      fontSize: '12px',
                                      textDecoration: 'none',
                                      color: '#3b82f6',
                                      whiteSpace: 'nowrap'
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setShowAllPurposes({yardValue: yard.value, yardLabel: yard.label});
                                    }}
                                  >
                                    view all
                                  </button>
                            </div>
                          ))}
                        </div>
                      )}
                  </div>
              </div> */}
            
                <div className='d-flex border-bottom border-secondary'>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>04.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>આ યોજના હેઠળ કયા કયા હેતુઓ માટે સહાય મેળવવા માંગો છો ? (Purpose(s) for which assistance is requested under this scheme).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>

<button
  type="button"
  className="btn btn-link p-0"
  style={{
    textDecoration: 'none',
    backgroundColor: 'transparent',
    color: '#3b82f6',
    border: 'none',
    whiteSpace: 'nowrap',
    transition: 'color 0.2s ease',
  }}

  onClick={() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }}
>
  View Selected Yards and Purposes
</button>
                  
                    </div>
                </div>
                <div className='d-flex border-bottom border-secondary'>
                  <h4 className='col-1 d-flex align-items-center justify-content-center'>05.</h4>
                  <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                    <p className='p-2'>આ હેતુઓ માટેની પ્રોજેકટ કિંમત કેટલી છે?(પ્લાન અને એસ્ટીમેઇટ) અસલમાં બીડવા. Estimated project cost for these purposes (Layout plan and estimate to be submitted with original documents).*</p>
                  </div>
                  <div className='col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center'>
  {getAllSelectedPurposes().length > 0 ? (
    <>
      {getAllSelectedPurposes().map((purpose, index) => (
        <div key={purpose.id} className="w-75 d-flex flex-column gap-1">
          <label className="small text-muted">
            {index + 1}. {extractEnglish(purpose.label)}
          </label>
          <input
            className="form-control"
            type="number"
            inputMode="decimal"
            min={0}
            placeholder="Enter cost"
            value={formData.purposeCosts[purpose.id] || ""}  // CHANGED
            onChange={(e) => handlePurposeCostChange(purpose.id, e.target.value)}
            onKeyDown={(e) => {
              if (e.key === '-' || e.key === 'e') e.preventDefault();
            }}
          />
        </div>
      ))}
      
      {/* ADD THIS ERROR DISPLAY */}
      {errors?.purposeCosts && (
        <span className="text-danger small w-75">{errors.purposeCosts}</span>
      )}
      
      {/* File upload for plan/estimate */}
      <div className="w-75 d-flex flex-column gap-1 mt-2">
        <label className="small text-muted">Upload Plan & Estimate Document</label>
        <input 
          className='form-control' 
          type='file' 
          onChange={(e) => handleFileChange(e, "planProjectCost")} 
          name="planProjectCost" 
          accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
          id='uploadPlan' 
          onBlur={handleBlur} 
          ref={refs.planProjectCost}
        />
        {formData?.planProjectCost && (
          <p className="small text-success">Uploaded: {formData?.planProjectCost?.fileName}</p>
        )}
        {errors && errors.planProjectCost && (
          <span className="text-danger small">{errors.planProjectCost}</span>
        )}
      </div>
    </>
  ) : (
    <p className="text-muted small">Please select yards and purposes first</p>
  )}
</div>
                </div>

                <div className='d-flex border-bottom border-secondary'>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>06.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>આ યોજના હેઠળ પ્રોજેકટ કિંમતના કેટલા ટકા મુજબ સહાય મળવાપાત્ર છે ? (What percentage of project cost is eligible for assistance under this scheme?).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column gap-2 align-items-center justify-content-center'>
                      <input
                        className='form-control w-75'
                        type='text'
                        inputMode='decimal'
                        id='percentOfProjCostEligible'
                        name='percentOfProjCostEligible'
                        placeholder='0 - 100'
                        value={formData.percentOfProjCostEligible ?? ""}
                        onChange={handlePercentageChange}
                        onBlur={handlePercentageBlur}
                        ref={refs.percentOfProjCostEligible}
                      />
                      {errors && errors.percentOfProjCostEligible && (
                          <span className="text-danger small">{errors.percentOfProjCostEligible}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary '>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>07.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>પ્લાન અને અંદાજો માન્ય પેનલ પરના એન્જીનીયરે તૈયાર કરેલા  અને જે વર્ષે અરજી કરી હોય તે વર્ષના અથવા અદ્યતન એસ.ઓ. આર. સામેલ છે ? તેની નકલ(અસલમાં રજૂ કરવા.) Plan and estimate prepared by an approved panel engineer and as per the applicable/current SOR (Schedule of Rates) for the year of application (Copy required).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column gap-2 align-items-center justify-content-center'>
                       <input className='form-control w-75' type='file' onChange={(e)=>handleFileChange(e,"planEstimateByApprovedPE")} name="planEstimateByApprovedPE"  accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"  id='uploadPlan' onBlur={handleBlur} ref={refs.planEstimateByApprovedPE}></input>
                       { formData?.planEstimateByApprovedPE && <p className="small text-success">Uploaded :{formData?.planEstimateByApprovedPE?.fileName }</p>}
                {errors && errors.planEstimateByApprovedPE && (
                          <span className="text-danger small">{errors.planEstimateByApprovedPE}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary'>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>08.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>જે જગ્યાના પ્લાન રજૂ કરેલ છે તે જગ્યા ઉપર અન્ય કોઇ બાંધકામ થયેલ છે કે કેમ ? (Is there any existing construction on the proposed project site?).*</p>
                    </div>
                    <div className='col-5 d-flex  flex-column align-items-center justify-content-center'>
                        <div className='d-flex m-2 flex-column align-items-start justify-content-center w-75'>
                            <div className=' d-flex justify-start gap-2'>
                            <input
                              type='radio'
                              name='isExistingConstructionOnProjSite'
                              value="yes"
                              checked={formData.isExistingConstructionOnProjSite === "yes"}
                              onChange={handleInputChange}
                              ref={refs.isExistingConstructionOnProjSite}
                            />Yes
                            <input
                              type='radio'
                              name='isExistingConstructionOnProjSite'
                              value="no"
                              checked={formData.isExistingConstructionOnProjSite === "no"}
                              onChange={handleInputChange}
                            />No
                            </div>
                            {errors && errors.isExistingConstructionOnProjSite && (
                              <span className="text-danger small">{errors.isExistingConstructionOnProjSite}</span>
                            )}
                            <div className='w-100'>
                              {/* estimatePlanConstruction */}
                              <input 
                                className='form-control w-100' 
                                type='file' 
                                onChange={(e)=>handleFileChange(e,"estimatePlanConstruction")} 
                                name="estimatePlanConstruction" 
                                accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"  
                                id='uploadPlan' onBlur={handleBlur} 
                                ref={refs.estimatePlanConstruction} 
                                // disabled={formData.isExistingConstructionOnProjSite !== "yes"}
                              />
                              { formData?.estimatePlanConstruction && <p className="small text-success">Uploaded :{formData?.estimatePlanConstruction?.fileName }</p>}
                              {errors && errors.estimatePlanConstruction && (
                                <span className="text-danger small">{errors.estimatePlanConstruction}</span>
                              )}
                            </div>
                        </div>
                    </div>
                </div>
 
                <div className='d-flex border-bottom border-secondary'>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>09.</h4>
                   <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>સાધનો કે ઓજારો ખરીદવાના હોય તો તેના અસલ ક્વોટેશન સામેલ છે ? તેની નકલ (If tools/equipment are to be purchased, are original quotations attached?).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column gap-2 align-items-center justify-content-center'>
                       <input className='form-control w-75' type='file' onChange={(e)=>handleFileChange(e,"toolsEquipQuotations")} name="toolsEquipQuotations" accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"  id='uploadPlan' onBlur={handleBlur} ref={refs.toolsEquipQuotations}></input>
                        { formData?.toolsEquipQuotations && <p className="small text-success">Uploaded :{formData?.toolsEquipQuotations?.fileName }</p>}
                {errors && errors.toolsEquipQuotations && (
                          <span className="text-danger small">{errors.toolsEquipQuotations}</span>
                        )}
                    </div>
                </div>
 
                <div className='d-flex'>
                    <h4 className='col-1 d-flex align-items-center justify-content-center'>10.</h4>
                    <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                        <p className='p-2'>અંદાજો જાહેર બાંધકામ ખાતાના માન્ય એસ.ઓ.આર. મુજબના છે તે સરકારશ્રીનું સંબંધિત ઈજનેરશ્રીનું પ્રમાણપત્ર સામેલ છે ? તેની નકલ રજુ કરવી (Are the estimates as per the approved SOR of the Public Works Department and are the certificates of the concerned engineer of the government included? A copy of the same should be submitted.).*</p>
                    </div>
                    <div className='col-5 d-flex flex-column gap-2 align-items-center justify-content-center'>
                       <input className='form-control w-75' type='file' onChange={(e)=>handleFileChange(e,"estimateCertifiedByGovtEngineer")} name="estimateCertifiedByGovtEngineer"   accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"  id='uploadPlan' onBlur={handleBlur} ref={refs.estimateCertifiedByGovtEngineer}></input>
                        { formData?.estimateCertifiedByGovtEngineer && <p className="small text-success">Uploaded :{formData?.estimateCertifiedByGovtEngineer?.fileName }</p>}
                {errors && errors.estimateCertifiedByGovtEngineer && (
                          <span className="text-danger small">{errors.estimateCertifiedByGovtEngineer}</span>
                        )}
                    </div>
                </div>
 
              </div>}
            </div>
            { !isGettingApplication && <div className="d-flex justify-content-end mb-3">
              <button className="btn btn-info " onClick={handleNextClick}>Next</button>
            </div>}
        {/* </div> */}
  {/* Modal for viewing all purposes */}
      {showAllPurposes && yardPurposes[showAllPurposes.yardValue] && (
        <>
          {/* Backdrop/Overlay */}
          <div 
            className="position-fixed top-0 start-0 w-100 h-100" 
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1050
            }}
            onClick={() => setShowAllPurposes(null)}
          ></div>
          
          {/* Popup Content */}
          <div 
            className="position-fixed top-50 start-50 translate-middle bg-white rounded shadow-lg" 
            style={{
              zIndex: 1051,
              maxWidth: '80vw',
              width: '90%',
              maxHeight: '80vh',
              overflow: 'auto'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-4">
              <div className="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
                <h5 className="mb-0">All Purposes for {showAllPurposes.yardLabel}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowAllPurposes(null)}
                  aria-label="Close"
                ></button>
              </div>
              
              <div className="d-flex flex-column gap-2">
                {yardPurposes[showAllPurposes.yardValue].map((purpose, index) => (
                  <div 
                    key={purpose.value} 
                    className="p-1rounded d-flex align-items-center"
                    // style={{backgroundColor: '#f8f9fa'}}
                  >
                    <span className="border text-black text-center me-3" style={{minWidth: '30px'}}>{index + 1}</span>
                    <span>{purpose.label}</span>
                  </div>
                ))}
              </div>

              <div className="mt-4 pt-3 border-top">
                <button 
                  type="button"
                  className="btn btn-info w-100" 
                  onClick={() => setShowAllPurposes(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </>
      )}
            {submitLoading && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          aria-hidden="true"
          tabIndex={-1}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div
                className="modal-body d-flex flex-column justify-content-center align-items-center"
                style={{ minHeight: 150 }}
              >
                {/* Spinner */}
                <div className="spinner-border text-primary mb-3" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>

                {/* Status text */}
                <h4 className="text-primary">Creating new application</h4>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
    </>
  )
}

export default APMCp1